"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathSymbol = exports.PathProps = exports.PathType = exports.EngineKeywords = void 0;
var EngineKeywords;
(function (EngineKeywords) {
    EngineKeywords["PRODUCER"] = "producer";
    EngineKeywords["VIEW"] = "view";
    EngineKeywords["GET"] = "get";
    EngineKeywords["OBSERVE"] = "observe";
    EngineKeywords["UPDATE"] = "update";
    EngineKeywords["PROP"] = "prop";
    EngineKeywords["ARG"] = "arg";
})(EngineKeywords = exports.EngineKeywords || (exports.EngineKeywords = {}));
var PathType;
(function (PathType) {
    PathType["GET"] = "get";
    PathType["OBSERVE"] = "observe";
    PathType["UPDATE"] = "update";
    PathType["PROP"] = "prop";
    PathType["ARG"] = "arg";
})(PathType = exports.PathType || (exports.PathType = {}));
var PathProps;
(function (PathProps) {
    PathProps["EXTERNAL"] = "prop";
    PathProps["INTERNAL"] = "arg";
    PathProps["PARAM"] = "param";
})(PathProps = exports.PathProps || (exports.PathProps = {}));
var PathSymbol;
(function (PathSymbol) {
    PathSymbol["EXTERNAL"] = "@";
    PathSymbol["INTERNAL"] = "$";
    PathSymbol["INVOKABLE"] = ":";
})(PathSymbol = exports.PathSymbol || (exports.PathSymbol = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFjcm8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbWFjcm8udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBR0EsSUFBWSxjQVFYO0FBUkQsV0FBWSxjQUFjO0lBQ3hCLHVDQUFxQixDQUFBO0lBQ3JCLCtCQUFhLENBQUE7SUFDYiw2QkFBVyxDQUFBO0lBQ1gscUNBQW1CLENBQUE7SUFDbkIsbUNBQWlCLENBQUE7SUFDakIsK0JBQWEsQ0FBQTtJQUNiLDZCQUFXLENBQUE7QUFDYixDQUFDLEVBUlcsY0FBYyxHQUFkLHNCQUFjLEtBQWQsc0JBQWMsUUFRekI7QUFFRCxJQUFZLFFBTVg7QUFORCxXQUFZLFFBQVE7SUFDbEIsdUJBQVcsQ0FBQTtJQUNYLCtCQUFtQixDQUFBO0lBQ25CLDZCQUFpQixDQUFBO0lBQ2pCLHlCQUFhLENBQUE7SUFDYix1QkFBVyxDQUFBO0FBQ2IsQ0FBQyxFQU5XLFFBQVEsR0FBUixnQkFBUSxLQUFSLGdCQUFRLFFBTW5CO0FBRUQsSUFBWSxTQUlYO0FBSkQsV0FBWSxTQUFTO0lBQ25CLDhCQUFpQixDQUFBO0lBQ2pCLDZCQUFnQixDQUFBO0lBQ2hCLDRCQUFlLENBQUE7QUFDakIsQ0FBQyxFQUpXLFNBQVMsR0FBVCxpQkFBUyxLQUFULGlCQUFTLFFBSXBCO0FBRUQsSUFBWSxVQUlYO0FBSkQsV0FBWSxVQUFVO0lBQ3BCLDRCQUFjLENBQUE7SUFDZCw0QkFBYyxDQUFBO0lBQ2QsNkJBQWUsQ0FBQTtBQUNqQixDQUFDLEVBSlcsVUFBVSxHQUFWLGtCQUFVLEtBQVYsa0JBQVUsUUFJckIifQ==